import React from 'react';
import type { Stat } from '../data/caseStudy';
type MetricCardProps = {
  stat: Stat;
  tone?: 'navy' | 'light';
  size?: 'md' | 'lg';
};
export function MetricCard({
  stat,
  tone = 'light',
  size = 'md'
}: MetricCardProps) {
  const surface = tone === 'navy' ? 'bg-white/[0.04] border-white/10' : 'bg-white border-line shadow-card';
  const valueColor = tone === 'navy' ? 'text-white' : 'text-navy';
  const labelColor = tone === 'navy' ? 'text-white/55' : 'text-ink-muted';
  const valueSize = size === 'lg' ? 'text-[64px]' : 'text-[40px]';
  return <div className={`avoid-break rounded-2xl border p-7 ${surface}`} data-id="element-44" data-mp="3jgqt0ubtn95a">
      <div className="accent-rule h-[3px] w-10 rounded-full" aria-hidden="true" data-id="element-45" data-mp="27u3cjdvo6ze" />
      <p className={`tabular mt-6 font-display ${valueSize} font-semibold leading-none tracking-[-0.03em] ${valueColor}`} data-id="element-46" data-mp="3tbio9rhxljww">
        {stat.value}
      </p>
      <p className={`mt-4 font-sans text-[13px] leading-[1.6] ${labelColor}`} data-id="element-47" data-mp="18ml7cvyas7xn">{stat.label}</p>
    </div>;
}